export const checkBrowser = function () {
  const ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) && ua.match(/MicroMessenger/i)[0] === 'micromessenger') {
    return 'WECHAT'
  }
  if (ua.match(/AliPay/i) && ua.match(/AliPay/i)[0] === 'alipay') {
    return 'ALIPAY'
  }
  return process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test' ? 'ALIPAY' : 'APP'
}
